import {
  StyledMenu,
  StyledOutletLayout,
} from "../../../../../../../components/common/styles";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../../store/config";
import {
  getTrainingProgramStart,
  resetTrainingProgram,
  getGroupsStart,
} from "../../../../../../../store/features/training-program/training-program-slice";

interface MenuItem {
  key: string;
  label: string;
  path: string;
  disabled?: boolean;
}

export const TrainingProgram = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { trainingProgramId } = useParams<{ trainingProgramId: string }>();
  const { workoutId } = useParams<{ workoutId: string }>();
  const { id: trainerId } = useParams<{ id: string }>();

  const menuItems: MenuItem[] = [
    {
      key: "training-program-details",
      label: t("Training Programs Details"),
      path: ``,
    },
    {
      key: "workouts",
      label: t("Workouts"),
      path: `workouts`,
      disabled: trainingProgramId === "add",
    },
  ];
  const [currentTab, setCurrentTab] = useState<string>(menuItems[0].key);

  useEffect(() => {
    if (trainingProgramId && trainingProgramId !== "add") {
      dispatch(getTrainingProgramStart({ trainingProgramId, trainerId }));
    } else if (trainerId) {
      dispatch(getGroupsStart(trainerId));
    }
    return () => {
      dispatch(resetTrainingProgram());
    };
  }, [dispatch, trainingProgramId]);

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    if (currentPath) {
      const activeTab = menuItems.find(
        (item) => item.path === currentPath
      )?.key;
      activeTab ? setCurrentTab(activeTab) : setCurrentTab(menuItems[0].key);
    }
  }, [location.pathname, menuItems]);

  return (
    <>
      {!workoutId && (
        <StyledMenu
          selectedKeys={[currentTab]}
          mode="horizontal"
          items={menuItems}
          onClick={(e) => {
            setCurrentTab(e.key);
            navigate(menuItems.find((item) => item.key === e.key)?.path || ``);
          }}
        />
      )}
      <StyledOutletLayout>
        <Outlet />
      </StyledOutletLayout>
    </>
  );
};
